import script from "./ModalLiqPrice.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalLiqPrice.vue?vue&type=script&setup=true&lang=js"

import "./ModalLiqPrice.vue?vue&type=style&index=0&id=337399ee&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-337399ee"]])

export default __exports__